import cleanObject from "app/shared-components/util/cleanObject";
import {convertToPlain} from "app/shared-components/utils";
import {defaultOrgCover, defaultOrgLogo} from "app/configs/themesConfig";
import generateAddressSchema from "app/shared-components/helmet/generateAddressSchema";

const generateOrgSchema = ({ organization, includeContext } ) => {
    const orgName= organization.name;
    const id=  organization.id;
    const uniqueName= organization.uniqueName;
    const description= convertToPlain(organization.description);
    const host = window.location.protocol + '//' + window.location.host;
    const orgLogo=  organization.logoImageUrl ? organization.logoImageUrl : defaultOrgLogo;
    const orgImage=  organization.headerImageUrl ? organization.headerImageUrl : defaultOrgCover;
    const baseUrl= host + "/public/organization/";
    const uniqueNameUrl= uniqueName ? baseUrl + uniqueName : null;
    const idUrl= baseUrl + organization.id;
    const canonicalUrl= uniqueNameUrl ? uniqueNameUrl : idUrl;
    const webUrl= organization.website ? organization.website : null;

    const schema = {
        ...(includeContext && { "@context": "https://schema.org" }),
        "@type": "Organization",
        "name": orgName,
        ...(uniqueName && { "alternateName": uniqueName }),
        "identifier": id,
        "url": canonicalUrl,
        ...(description && { "description": description }),
        ...(orgImage && { "image": orgImage }),
        ...(orgLogo && { "logo": orgLogo }),
        ...(organization?.email && { "email": organization.email }),
        ...(organization?.phone && { "telephone": organization.phone }),
        ...(webUrl && { "sameAs": webUrl }),
        "address": generateAddressSchema(organization, "USA")
    };

    return cleanObject(schema);
};

export default generateOrgSchema;